import '~publish/boot/polyfills'

// Must stay the first app import after polyfills: installs Sentry and the
// pre-mount failure handlers before the rest of the module graph evaluates,
// so a top-level throw below this line still surfaces the mount failure
// screen (CORE-5604).
import '~publish/boot/installPreMountErrorHandlers'

import * as ReactDOM from 'react-dom/client'

import { APP_ROOT_ID, registerAppRoot } from '~publish/components/MountFailure'
import { env } from '~publish/env'
import { checkAuthDoor } from '~publish/helpers/oidcAuth'
import { logError } from '~publish/legacy/utils/logError'
import { initMocktail } from '~publish/mocktail'

import { PublishRoot } from './components/PublishRoot'
import { installBrowserTranslationCrashGuard } from './browserTranslationCrashGuard'

// Make React tolerant of browser translation (e.g. Google Translate) re-parenting
// text nodes into <font> wrappers. Must run before React mounts. See the module
// for the mechanism / facebook/react#11538.
installBrowserTranslationCrashGuard()

void checkAuthDoor()
void initMocktail()
  .then(() => {
    if (!window['__publishBootFailureShown']) {
      window.API_GATEWAY_URL = env.VITE_GRAPHQL_API
      window.VERSION =
        env.VITE_NODE_ENV === 'development' ? 'local' : env.VITE_COMMIT_HASH
      // used in async-data-fetch to pass as a header to track in DD custom metrics
      window.xBufferClientId = env.VITE_X_BUFFER_CLIENT_ID
      window.xBufferClientVersion =
        env.VITE_COMMIT_HASH && env.VITE_COMMIT_HASH !== 'undefined'
          ? env.VITE_COMMIT_HASH
          : undefined

      const rootEl = document.getElementById(APP_ROOT_ID)
      if (rootEl) {
        const root = ReactDOM.createRoot(rootEl)
        registerAppRoot(root)

        // render() does not throw synchronously in React 18; render-phase failures
        // surface as async uncaught errors handled by setupPreMountErrorHandlers.
        root.render(<PublishRoot />)
      } else {
        logError(
          new Error('Could not find the publish-frontend root element.'),
          {
            context: 'mountPublishFrontend',
          },
        )
      }
    }
    return undefined
  })
  .catch((error: unknown) => {
    logError(error, { context: 'mountPublishFrontend' })
  })
